import {
  Col, Flex, Row, Typography
} from "antd";
import { NavLink } from "react-router-dom";
import Layout from "../components/layout";
import HeroScreen from "../components/HeroScreen/heroScreen";
import classes from "../components/HeroScreen/heroScreen.module.css";
import { data } from "../data/psychologists";
import Container from "../components/container";

const expertsArray = Array.from(data.entries());
const { Paragraph } = Typography;

const ExpertCard = ({ entity, expertData }: { entity: string, expertData: any }) => {
  return (
    <NavLink to={`/psiconcologi/${entity}`} className="relative block">
      <img src={`/landing/experts/${entity}.webp`} alt={entity} className="w-full" />
      <div
        className="absolute bottom-0 left-0 backdrop-blur-[8px] p-[1.5rem] text-white w-full bg-[#9b9b9b]/30"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className="absolute top-[24px] right-[24px]"
        >
          <path d="M7 17L17 7M17 7H7M17 7V17" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span className="text-[2rem] font-bold block mb-[16px] leading-[1] pr-[24px]">{expertData.name}</span>
        <span className="text-base block mb-[8px]">{expertData.role}</span>
        <Paragraph ellipsis={{ rows: 2 }} className="text-base text-white !mb-0">
          {expertData.description[0]}
        </Paragraph>
      </div>
    </NavLink>
  );
};

const Experts = () => {
  return (
    <Layout>
      <HeroScreen imgSrc="/landing/experts/hero.png">
        <h1 className="heroTitle">Chi Siamo?</h1>
        <Flex
          vertical
          gap={16}
          className={classes.text}
        >
          <p>
            Siamo un team di psiconcologi certificati impegnato a fornire un
            aiuto prezioso ai pazienti affetti da cancro e ai loro caregiver
            in ogni fase della loro battaglia contro la malattia.
          </p>
          <p>
            Ci impegniamo a garantire un ambiente accogliente,
            informativo e solidale, dove ogni individuo possa trovare risorse,
            supporto emotivo e informazioni affidabili.
          </p>
        </Flex>
      </HeroScreen>
      <Container>
        <Flex vertical gap="3rem" className="py-[1.5rem]">
          <Row>
            <Col
              span={24}
              lg={{
                span: 8,
                offset: 8
              }}
            >
              <ExpertCard entity={expertsArray[0][0]} expertData={expertsArray[0][1]} />
            </Col>
          </Row>
          <Row gutter={[32, 32]}>
            {Array.from(data.entries()).map(([key, expert], index) => index !== 0 && (
            <Col
              key={key}
              span={24}
              lg={{
                span: 8,
              }}
            >
              <ExpertCard entity={key} expertData={expert} />
            </Col>
            ))}
          </Row>
        </Flex>
      </Container>
    </Layout>
  );
};

export default Experts;
